import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const UserEventModal = ({
    show,
    event,
    onClose,
}) => {
    if (!event) return null;

    const data = event;

    const assignedPerson =
        data.inspectorName ||
        data.carpenterName ||
        data.directorName ||
        "Not assigned";

    const assignedRole = data.carpenterName
        ? "Carpenter"
        : data.inspectorName || data.directorName
            ? "Inspector"
            : "Assigned To";

    const formatDateTime = (value) => {
        if (!value) return "—";

        const date =
            value instanceof Date
                ? value
                : new Date(value);

        if (Number.isNaN(date.getTime())) {
            return "—";
        }

        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const getEndTravelTime = () => {
        if (!data.start) return null;

        const start = new Date(data.start);

        if (Number.isNaN(start.getTime())) {
            return null;
        }

        return new Date(
            start.getTime() +
            Number(data.travelTimeMinutes || 0) *
            60 *
            1000
        );
    };

    const getStartInspectionTime = () => {
        return getEndTravelTime();
    };

    const sectionStyle = {
        backgroundColor: "#ffffff",
        border: "1px solid #e6e9ed",
        borderRadius: "10px",
        padding: "14px",
    };

    const sectionTitleStyle = {
        fontSize: "12px",
        fontWeight: "700",
        color: "#343a40",
        marginBottom: "12px",
        textTransform: "uppercase",
        letterSpacing: "0.45px",
    };

    const labelStyle = {
        fontSize: "12px",
        fontWeight: "600",
        color: "#6c757d",
        marginBottom: "5px",
    };

    const valueStyle = {
        backgroundColor: "#f8f9fa",
        border: "1px solid #e2e6ea",
        borderRadius: "7px",
        minHeight: "42px",
        padding: "9px 11px",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "500",
        color: "#212529",
        wordBreak: "break-word",
    };

    return (
        <>
            <style>
                {`
                    .user-event-modal {
                        width: calc(100% - 32px);
                        max-width: 760px !important;
                        margin-left: auto;
                        margin-right: auto;
                    }

                    .user-event-blur-backdrop {
                        background-color: rgba(20, 25, 30, 0.30) !important;
                        backdrop-filter: blur(7px);
                        -webkit-backdrop-filter: blur(7px);
                        opacity: 1 !important;
                    }

                    .user-event-modal .modal-content {
                        border: 0;
                        border-radius: 14px;
                        overflow: hidden;
                        box-shadow:
                            0 20px 60px rgba(0, 0, 0, 0.20),
                            0 4px 18px rgba(0, 0, 0, 0.08);
                    }

                    .user-general-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 10px;
                    }

                    .user-schedule-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 10px;
                    }

                    .user-location-grid {
                        display: grid;
                        grid-template-columns: 2fr 1fr 1fr;
                        gap: 10px;
                    }

                    .user-door-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 10px;
                    }

                    @media (max-width: 767px) {
                        .user-event-modal {
                            width: calc(100% - 24px);
                            max-width: none !important;
                            margin: 12px auto;
                        }

                        .user-location-grid {
                            grid-template-columns: 1fr 1fr;
                        }

                        .user-location-address {
                            grid-column: 1 / -1;
                        }
                    }

                    @media (max-width: 575px) {
                        .user-event-modal {
                            width: calc(100% - 16px);
                            margin: 8px auto;
                        }

                        .user-general-grid,
                        .user-schedule-grid,
                        .user-location-grid,
                        .user-door-grid {
                            grid-template-columns: 1fr;
                        }

                        .user-location-address {
                            grid-column: auto;
                        }

                        .user-event-modal .modal-header {
                            padding: 13px 14px !important;
                        }

                        .user-event-modal .modal-body {
                            padding: 10px !important;
                        }

                        .user-event-modal .modal-footer {
                            padding: 10px !important;
                        }
                    }
                `}
            </style>

            <Modal
                show={show}
                onHide={onClose}
                centered
                backdrop="static"
                keyboard
                dialogClassName="user-event-modal"
                backdropClassName="user-event-blur-backdrop"
            >
                <Modal.Header
                    closeButton
                    style={{
                        padding: "14px 16px",
                        borderBottom: "1px solid #e9ecef",
                        backgroundColor: "#ffffff",
                    }}
                >
                    <div style={{ minWidth: 0 }}>
                        <div
                            style={{
                                fontSize: "11px",
                                color: "#6c757d",
                                fontWeight: 600,
                                marginBottom: "2px",
                            }}
                        >
                            Event Details
                        </div>

                        <Modal.Title
                            style={{
                                fontSize: "19px",
                                fontWeight: 700,
                                lineHeight: 1.25,
                                margin: 0,
                                color: "#212529",
                                wordBreak: "break-word",
                            }}
                        >
                            {data.title || "Scheduled Event"}
                        </Modal.Title>
                    </div>
                </Modal.Header>

                <Modal.Body
                    style={{
                        backgroundColor: "#f5f6f8",
                        padding: "14px",
                        maxHeight: "72vh",
                        overflowY: "auto",
                    }}
                >
                    <div
                        style={{
                            display: "grid",
                            gap: "12px",
                        }}
                    >
                        <div style={sectionStyle}>
                            <div style={sectionTitleStyle}>
                                General Information
                            </div>

                            <div className="user-general-grid">
                                <div>
                                    <div style={labelStyle}>
                                        Client Email
                                    </div>

                                    <div style={valueStyle}>
                                        {data.buildingEmail || "—"}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        {assignedRole}
                                    </div>

                                    <div style={valueStyle}>
                                        {assignedPerson}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={sectionStyle}>
                            <div style={sectionTitleStyle}>
                                Schedule
                            </div>

                            <div className="user-schedule-grid">
                                <div>
                                    <div style={labelStyle}>
                                        Start Travel Time
                                    </div>

                                    <div style={valueStyle}>
                                        {formatDateTime(data.start)}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        End Travel Time
                                    </div>

                                    <div style={valueStyle}>
                                        {formatDateTime(
                                            getEndTravelTime()
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        Start Inspection Time
                                    </div>

                                    <div style={valueStyle}>
                                        {formatDateTime(
                                            getStartInspectionTime()
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        End Inspection Time
                                    </div>

                                    <div style={valueStyle}>
                                        {formatDateTime(data.end)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={sectionStyle}>
                            <div style={sectionTitleStyle}>
                                Location
                            </div>

                            <div className="user-location-grid">
                                <div className="user-location-address">
                                    <div style={labelStyle}>
                                        Building Address
                                    </div>

                                    <div style={valueStyle}>
                                        {data.buildingAddress || "—"}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        City
                                    </div>

                                    <div style={valueStyle}>
                                        {data.buildingCity || "—"}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        Postcode
                                    </div>

                                    <div style={valueStyle}>
                                        {data.postcode || "—"}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={sectionStyle}>
                            <div style={sectionTitleStyle}>
                                Door Information
                            </div>

                            <div className="user-door-grid">
                                <div>
                                    <div style={labelStyle}>
                                        Communal Doors
                                    </div>

                                    <div style={valueStyle}>
                                        {data.totalCommunalDoors ?? "—"}
                                    </div>
                                </div>

                                <div>
                                    <div style={labelStyle}>
                                        Residential Doors
                                    </div>

                                    <div style={valueStyle}>
                                        {data.totalResiDoors ?? "—"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    style={{
                        padding: "10px 14px",
                        backgroundColor: "#ffffff",
                        borderTop: "1px solid #e9ecef",
                        display: "flex",
                        gap: "8px",
                        justifyContent: data.doorUrl
                            ? "space-between"
                            : "flex-end",
                    }}
                >
                    {data.doorUrl && (
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() =>
                                window.open(
                                    data.doorUrl,
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                            style={{
                                minWidth: "100px",
                                fontWeight: 600,
                            }}
                        >
                            View Door
                        </Button>
                    )}

                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={onClose}
                        style={{
                            minWidth: "80px",
                            fontWeight: 600,
                        }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UserEventModal;